























import { Component, Vue, Ref, PropSync, Prop, Watch } from "vue-property-decorator"
import { FormModel } from "ant-design-vue"
import { mapGetters } from "vuex"
import channelService from "@/services/channel.service"
import { deepClone } from "@/utils"

@Component({
    name: "CdnEdit",
    computed: {
        ...mapGetters("common", ["software_list"])
    }
})
export default class CdnEdit extends Vue {
    readonly software_list: any

    @PropSync("visible", { default: false })
    visible_: boolean

    @Prop({ type: String, default: "add" })
    fromType: string

    @Prop({ default: () => ({}) })
    lineData: object

    @Ref("ruleForm")
    refFrom: FormModel

    get changeTitle() {
        const title = this.fromType == "add" ? "添加CDN" : "编辑CDN"
        return title
    }
    fromModal: any = { software_id: null, cdn_domain: "" }

    @Watch("visible")
    assignment() {
        if (this.fromType == "edit") {
            const data = deepClone(this.lineData)
            this.fromModal = data
        } else if (this.fromType == "add") {
            // 新增时清空表单数据
            this.fromModal = { software_id: null, cdn_domain: "" }
        }
    }
    get rules() {
        return {
            software_id: [{ required: true, message: "必填", trigger: "blur" }],
            cdn_domain: [
                { required: true, message: "必填", trigger: "blur" },
                { validator: this.isValidCDNDomain }
            ]
        }
    }
    validCdn(text: string): boolean {
        // 域名正则表达式：支持子域名，允许连字符，必须以字母或数字结尾
        const domainRegex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/
        return domainRegex.test(text)
    }

    isValidCDNDomain(rule: any, v: string, callback: any) {
        // 检查是否包含协议
        const includeHttp = v.startsWith("http://") || v.startsWith("https://")
        if (includeHttp) {
            callback("CDN不包含http://或https://协议")
            return
        }

        // 验证域名格式
        if (!this.validCdn(v)) {
            callback("请输入正确的CDN域名格式！")
            return
        }

        callback()
    }

    // 添加文本类型
    async addMode() {
        try {
            await (this.$refs.ruleForm as any).validate()
            await channelService.createCdn(this.fromModal)
            this.$emit("upDataList")
            this.$message.success("新建成功")
            this.visible_ = false
            this.fromModal = { software_id: null, cdn_domain: "" }
            await (this.$refs.ruleForm as any).clearValidate()
        } catch (error) {
            this.$message.error(`创建失败！ ${error}`)
        }
    }
    // 编辑文本类型
    async editMode() {
        try {
            await (this.$refs.ruleForm as any).validate()
            await channelService.editCdn(this.fromModal)
            this.$emit("upDataList")
            this.$message.success("修改成功")
            this.visible_ = false
            this.fromModal = { software_id: null, cdn_domain: "" }
            await (this.$refs.ruleForm as any).clearValidate()
        } catch (error) {
            this.$message.error(`修改失败！ ${error}`)
        }
    }

    handleOk() {
        if (this.fromType == "add") {
            this.addMode()
        } else {
            this.editMode()
        }
    }
    async cancel() {
        this.visible_ = false
        this.fromModal = { software_id: null, cdn_domain: "" }
        await (this.$refs.ruleForm as any).clearValidate()
    }
}
